"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTxnAmount = exports.getDateRangeHeader = void 0;
var format_1 = __importDefault(require("date-fns/format"));
var dateTime_1 = require("utils/dateTime");
var getDateRangeHeader = function (startDate, endDate) {
    if (!startDate || !endDate)
        return null;
    var start = (0, dateTime_1.getMonthYearDate)(startDate, true);
    var end = (0, dateTime_1.getMonthYearDate)(endDate, true);
    if (start === end) {
        return start;
    }
    if (startDate.getFullYear() === endDate.getFullYear()) { // if same year show start date's month and year
        return "".concat((0, format_1.default)(startDate, 'MMM'), " - ").concat(end);
    }
    return "".concat(start, " - ").concat(end);
};
exports.getDateRangeHeader = getDateRangeHeader;
var convertTxnAmount = function (company) { return function (transaction) {
    var _a, _b, _c;
    if (!company)
        return 0;
    var amountInTransactionCurrency = (_a = (!transaction.isLineItem ? (transaction === null || transaction === void 0 ? void 0 : transaction.subTotal) || transaction.total : transaction.amount)) !== null && _a !== void 0 ? _a : 0;
    var baseCurrencyExchangeRate = (_b = transaction.exchangeRates) === null || _b === void 0 ? void 0 : _b[(_c = company === null || company === void 0 ? void 0 : company.baseCurrency) !== null && _c !== void 0 ? _c : 'AUD'];
    return amountInTransactionCurrency / (baseCurrencyExchangeRate !== null && baseCurrencyExchangeRate !== void 0 ? baseCurrencyExchangeRate : 1);
}; };
exports.convertTxnAmount = convertTxnAmount;
